import Launch from './launch.gif'
import Space from './space.gif'
import Lading from './landing.gif'
import Moon from './moon.gif'
import './RoadMapStyle.css'
const RoadMap = ()=>{
    return <>
    <section className='sec1 mar-top'>
        <div className='secStyle'>
            <img src={Launch} alt=''/>
        </div>
        <div className='secStyle1 padd-l'>
            <h2>Phase 1: Getting started</h2>
            <ul>
                <li>- Set up social Networks</li>
                <li>- Build our community</li>
                <li>- Rocket launching! (Launch mint)</li>
            </ul>
        </div>
    </section>

    <section className='sec1'>
        <div className='secStyle mob-fix'>
            <img src={Space} alt=''/>
        </div>
        <div className='secStyle1'>
            <h2>Phase 2: On Space</h2>
            <ul>
                <li>- Mint Out</li>
                <li>- Listing on Magic Eden & OpenSea</li>
                <li>- Holder's verification (Metahelix)</li>
                <li>- Utilities ( Whale wallet tracker, Analysis tools, Listings tracker & MORE.. )</li>
                <li>- Suprise collaboration</li>
            </ul>
        </div>
         <div className='secStyle desk-fix'>
            <img src={Space} alt=''/>
        </div>
    </section>

    <section className='sec1'>
         <div className='secStyle'>
            <img src={Lading} alt=''/>
        </div>
        <div className='secStyle1 padd-l2'>
            <h2>Phase 3: About to Land..</h2>
            <ul>
                <li>- Release $FUEL token & tokenomics</li>
                <li>- Release Staking for $FUEL</li>
                <li>- $FUEL initial utilities for Raffles & <br/> <span id="space">Auctions for NFTs & SOL</span></li>
            </ul>
        </div>
    </section>

    <section className='sec1'>
        <div className='secStyle mob-fix'>
            <img src={Moon} alt=''/>
        </div>
        <div className='secStyle1'>
            <h2>Phase 4: In the Moon</h2>
            <ul>
                <li>- Release our 2gen collection</li>
                <li>- Builder collaboration (based on community decision)</li>
                <li>- Mystery boxes</li>
            </ul>
        </div>
         <div className='secStyle desk-fix'>
            <img src={Moon} alt=''/>
        </div>
    </section>

    <section className='sec1 center'>
        <h2>Ride begins!! More to announce...</h2>
    </section>

    </>
}

export default RoadMap